
import { useRef, useState, useEffect } from "react";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from '../../api/axios';
import { Link, useNavigate, NavLink } from "react-router-dom";
import loginImg from '../../assets/images/login-img.png'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsEyeSlash, BsEye } from "react-icons/bs";
import workWiseLogo from '../../assets/images/workwise-logo-white.png';
const USER_REGEX = /^[0-9]{6,10}$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const OTP_REGEX = /^[0-9]{6,6}$/;
const FORGET_URL = '/forgetpassword';


function ForgetPassword() {

  const navigate = useNavigate();
  const [user, setUser] = useState('');
  const [validName, setValidName] = useState(false);
  const [userFocus, setUserFocus] = useState(false);
  const [pwd, setPwd] = useState('');
  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);
  const [matchPwd, setMatchPwd] = useState('');
  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);
  // const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [idFlag, setIdFlag] = useState(false);
  const [emailState, setEmailState] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [validOtp, setValidOtp] = useState(false);
  const [otpFocus, setOtpFocus] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [confirmpasswordStatus, setConfirmPasswordStatus] = useState("password");
  const [passwordStatus, setPasswordStatus] = useState("password");
  const [errMsg, setErrMsg] = useState({
    er_username : '',
    er_password : '',
    er_otp:'' ,
    er_con_password:''});

  const checkSysId = (e) => {
    e.preventDefault();
    if (user == "") {

      // toast.error("System ID is Required!", {
      //   position: toast.POSITION.TOP_RIGHT,
      //   theme: "colored",
      //   autoClose: 2000
      // });
      setErrMsg({...errMsg, er_username:"System Id is required!"})
    }
    else {
      axios.post('/forgetpassword', {
        username: user,
        otp: Math.floor(100000 + Math.random() * 900000),
      }).then((response) => {
        if (response.data.message == "true") {
          toast.success("OTP has been sent successfully to your registered email id: " + response.data.email, {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000
          });

          setUserEmail(response.data.email);
          setIdFlag(true);

        }

        else {
          if(response?.status === 202){
            toast.error("Your account is locked!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
            });
          }
          else{
            // toast.error("System ID does not exist!", {
            //   position: toast.POSITION.TOP_RIGHT,
            //   theme: "colored",
            //   autoClose: 2000
            // });
            setErrMsg({...errMsg, er_username:"System Id does not exist!"})
          }
         
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }

  const verifyOtp = (e) => {
    e.preventDefault();
    try {
      if (emailOtp == "") {
        // toast.error("Please provide OTP!", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   theme: "colored",
        //   autoClose: 2000
        // });
        setErrMsg({...errMsg, er_otp:"Please provide OTP!"})
      }
      else {
        axios.post('/checkotp', {
          otp: emailOtp,
          username: user,
        }).then((response) => {
          if (response.data) {
            toast.success("Please set your new password!", {
              position: toast.POSITION.TOP_RIGHT,
              theme: "colored",
              autoClose: 2000
            });
            setEmailState(response.data);
          }

          else {
            // toast.error("Incorrect OTP Entered!", {
            //   position: toast.POSITION.TOP_RIGHT,
            //   theme: "colored",
            //   autoClose: 2000
            // });
            setErrMsg({...errMsg, er_otp:"Incorrect OTP Entered!"})
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    } catch (err) {
      console.log(err);
      if (!err?.response) {
        toast.error("No Server Response!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });

      } else if (err.response?.status === 409) {
        toast.error("Username Already Exist!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });

      } else {
        toast.error("Forgot Password Failed!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    const v2 = PWD_REGEX.test(pwd);


    try {
      if (pwd == "") {
        // toast.error("Password is required!", {
        //   position: toast.POSITION.TOP_RIGHT,
        //   theme: "colored",
        //   autoClose: 2000
        // });
        setErrMsg({...errMsg, er_password:"Password is required!"})
      }

      else {
        if (!v2) {
          toast.error("Password must be of 8 to 24 characters - 1 uppercase, 1 lowercase, 1 number and a special character!", {
            position: toast.POSITION.TOP_RIGHT,
            theme: "colored",
            autoClose: 2000
          });
          return;
        }
        else {

          if (matchPwd == "") {
            // toast.error("Confirm password is required! ", {
            //   position: toast.POSITION.TOP_RIGHT,
            //   theme: "colored",
            //   autoClose: 2000
            // });
            setErrMsg({...errMsg, er_con_password:"Confirm password is required!"})
          }
          else {
            if (!validMatch) {
              // toast.error("Password does not matched!", {
              //   position: toast.POSITION.TOP_RIGHT,
              //   theme: "colored",
              //   autoClose: 2000
              // });
              setErrMsg({...errMsg, er_con_password:"Password does not matched!"})
            }
            else {
              axios.post('/newpassword', {
                username: user,
                password: pwd,
              }).then((response) => {
                if (response.data) {
                  toast.success("Password is changed succesfully!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                  });


                  setPwd('');
                  setMatchPwd('');
                  setTimeout(() => {
                    navigate("/", { replace: true });
                  }, 2000);
                }
              }).catch(function (error) {
                console.log(error);
              });


            }
          }
        }
      }
    } catch (err) {
      if (!err?.response) {
        toast.error("No Server Response!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      } else if (err.response?.status === 409) {
        toast.error("Username already exist!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      } else {
        toast.error("Registration Failed!", {
          position: toast.POSITION.TOP_RIGHT,
          theme: "colored",
          autoClose: 2000
        });
      }
    }
  }

  useEffect(() => {
    setValidName(USER_REGEX.test(user));
    setValidOtp(OTP_REGEX.test(emailOtp));
    setValidPwd(PWD_REGEX.test(pwd));
    setValidMatch(pwd === matchPwd);
    setErrMsg({
      er_username : '',
      er_password : '',
      er_otp:'' ,
      er_con_password:''
    })
  }, [user, emailOtp, pwd, matchPwd])

  return (
    <>
      <div className="Almuni">
        <div className="container-fluid p-0">
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="login-img">
                <div className="loginvedio">
                  <img src={loginImg} alt="Forgot Password Image" />
                </div>

                <div className="mask" >
                  <div className="mask-in">
                    <img src={workWiseLogo} alt="WorkWise Management Software" />
                    <h1>Project Management Software</h1>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-6">
              <div className="login-page ">
                <div className="login-field">
                  {idFlag ? (
                    emailState ? (
                      <div>
                        <h1>Forgot Password</h1>
                        <form onSubmit={handleSubmit} className="loginForm">
                          <div className="userField">
                            <label htmlFor="username">System ID</label>
                            <div className="input-icon">
                              <span className="icon"><i className="bi bi-x-circle"></i></span>
                              <input className="myInput disabled" type="text" id="username" value={user} disabled />
                            </div>
                          </div>
                          <div className="userField">
                            <label htmlFor="password">
                              Password:
                              <FontAwesomeIcon icon={faCheck} className={validPwd ? "valid" : "hide"} />
                              <FontAwesomeIcon icon={faTimes} className={validPwd || !pwd ? "hide" : "invalid"} />
                            </label>
                            <div className="input-icon">
                              {passwordStatus === "password" ? < NavLink className="icon" onClick={() => setPasswordStatus("text")} ><BsEyeSlash /></NavLink> :
                                <NavLink className="icon" onClick={() => setPasswordStatus("password")} ><BsEye /></NavLink>}

                              <input className="myInput"
                                type={passwordStatus}
                                id="password"
                                name="password"
                                onChange={(e) => (setPwd(e.target.value),setErrMsg({...errMsg,er_password : ''}))}
                                value={pwd}
                                aria-invalid={validPwd ? "false" : "true"}
                                aria-describedby="pwdnote"
                                onFocus={() => setPwdFocus(true)}
                                onBlur={() => setPwdFocus(false)}
                                placeholder="Please Enter Password"
                              />
                                {errMsg?.er_password && <div className="errMsg">{errMsg?.er_password}</div>}
                            </div>
                          </div>
                          <div className="userField">
                            <label htmlFor="confirm_pwd">
                              Confirm Password:
                              <FontAwesomeIcon icon={faCheck} className={validMatch && matchPwd ? "valid" : "hide"} />
                              <FontAwesomeIcon icon={faTimes} className={validMatch || !matchPwd ? "hide" : "invalid"} />
                            </label>
                            <div className="input-icon">
                              {confirmpasswordStatus === "password" ? < NavLink className="icon" onClick={() => setConfirmPasswordStatus("text")} ><BsEyeSlash /></NavLink> :
                                <NavLink className="icon" onClick={() => setConfirmPasswordStatus("password")} ><BsEye /></NavLink>}

                              <input className="myInput"
                                type={confirmpasswordStatus}
                                id="confirm_pwd"
                                onChange={(e) => (setMatchPwd(e.target.value),setErrMsg({...errMsg,er_con_password : ''}))}
                                value={matchPwd}
                                aria-invalid={validMatch ? "false" : "true"}
                                aria-describedby="confirmnote"
                                onFocus={() => setMatchFocus(true)}
                                onBlur={() => setMatchFocus(false)}
                                placeholder="Confirm Password"
                              />
                              {errMsg?.er_con_password && <div className="errMsg">{errMsg?.er_con_password}</div>}
                            </div>
                          </div>
                          <button className="login-btn1">Submit</button>
                          <strong>Back to <Link to="/">Sign in</Link></strong>
                        </form>
                      </div>
                    ) :
                      (
                        <div>
                          <h1>Forgot Password</h1>
                          <form onSubmit={verifyOtp} className="loginForm">
                            <div className="userField">
                              <label htmlFor="username">System ID</label>
                              <div className="input-icon">
                                <span className="icon"><i className="bi bi-x-circle"></i></span>
                                <input className="myInput disabled" type="text" id="username" value={user} disabled />
                              </div>
                            </div>
                            <div className="userField">
                              <label htmlFor="otp">
                                OTP:
                              </label>
                              <div className="input-icon">
                                <input className="myInput"
                                  type="number"
                                  id="otp"
                                  name="otp"
                                  onChange={(e) => (setEmailOtp(e.target.value),setErrMsg({...errMsg,er_otp : ''}))}
                                  value={emailOtp}
                                  aria-invalid={validOtp ? "false" : "true"}
                                  aria-describedby="pwdnote"
                                  onFocus={() => setOtpFocus(true)}
                                  onBlur={() => setOtpFocus(false)}
                                  placeholder="Please enter OTP"
                                  maxLength="6"
                                  minLength="6"
                                />
                                {errMsg?.er_otp && <div className="errMsg">{errMsg?.er_otp}</div>}
                              </div>
                            </div>
                            

                            <button className="login-btn1">Submit</button>
                            <strong>Back to <Link to="/">Sign in</Link></strong>
                          </form>
                        </div>
                      )
                  ) : (
                    <div>
                      <h1>Forgot Password</h1>
                      <form onSubmit={checkSysId} className="loginForm">
                        <div className="userField">
                          <label htmlFor="username">
                            System ID:
                            <FontAwesomeIcon icon={faCheck} className={validName ? "valid" : "hide"} />
                            <FontAwesomeIcon icon={faTimes} className={validName || !user ? "hide" : "invalid"} />
                          </label>
                          <div className="input-icon">
                            <input className="myInput"
                              type="text"
                              id="username"
                              name="username"
                              // ref={userRef}
                              autoComplete="off"
                              onChange={(e) => (setUser(e.target.value),setErrMsg({...errMsg,er_username : ''}))}
                              value={user}
                              aria-invalid={validName ? "false" : "true"}
                              aria-describedby="uidnote"
                              onFocus={() => setUserFocus(true)}
                              onBlur={() => setUserFocus(false)}
                              placeholder="Please enter System ID"
                            />
                            {errMsg?.er_username && <div className="errMsg">{errMsg?.er_username}</div>}
                          </div>
                        </div>
                        <button className="login-btn1">Submit</button>
                        <strong>Back to <Link to="/">Sign in</Link></strong>
                      </form>

                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ForgetPassword; 